module.exports = __webpack_public_path__ + "3eb1f8116d1509d06befb5a423cb76f3.png";